import {getAmount, updateAmount} from "../api_services/amount";
import React, {useEffect, useState} from "react";

export const DefineAmount = () => {

    const [amount, setAmount] = useState(0);
    const [amountLoading, setAmountLoading] = useState(false);

    useEffect(() => {
        const fetchAmount = async () => {
            setAmountLoading(true);
            try {
                const response = await getAmount();
                setAmount(response.amount || 0);
            } catch (error) {
                console.error("Failed to fetch amount:", error);
            } finally {
                setAmountLoading(false);
            }
        };
        fetchAmount();
    }, []);

    const onChangeAmount = async (newAmount) => {
        const numericAmount = parseFloat(newAmount) || 0;
        setAmountLoading(true);
        try {
            setAmount(numericAmount);
            await updateAmount(numericAmount);
        } catch (error) {
            console.error("Error updating amount:", error);
        } finally {
            setAmountLoading(false);
        }
    };



    return (
        <div>
            <div className="w-full sm:w-auto flex gap-4 items-center">
                <span className="bg-[#02006c] px-2 py-1 rounded-lg text-white">Trade $</span>
                <input
                    type="number"
                    placeholder="Enter amount"
                    value={amount === 0 ? '' : amount}
                    onChange={(e) => onChangeAmount(e.target.value)}
                    className="px-4 py-2 border text-white bg-[#010057] rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full sm:w-32"
                />
                {amountLoading && (
                    <svg className="animate-spin h-5 w-5 text-white" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" fill="currentColor"/>
                        <path className="opacity-75" fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
                    </svg>
                )}
            </div>
        </div>
    );
}
